import DateUtils from '../Utils/DateUtils';
import { getRandom } from '../Utils/Utils';
import { ItemIDs } from './Items';

const COLLECT_STARS = [[3, 5], [6, 9], [10, 12]];

const COMPLETE_LEVELS = [[1, 3], [4, 5], [6, 7]];

const MATCH_TILES = [[90, 140], [150, 200], [210, 250]];

const MATCH_GOLD = [[8, 10], [15, 20], [30, 40]];

const COLLECT_TOYS = [[20, 30], [40, 50], [51, 60]];

const USE_HINT = [[1, 2], [3, 4], [5, 6]];

const USE_FIRECRACKER = [[1, 2], [3, 4], [5, 6]];

const USE_MAGNET = [[1], [2], [3]];

const REACH_COMBO = [[8], [9], [10]];

interface IMissionConfig {
    collectStars: number[][];
    collectToys: number[][];
    completeLevels: number[][];
    matchTiles: number[][];
    matchGold: number[][];
    use_hint: number[][];
    use_firecracker: number[][];
    use_magnet: number[][];
    reachCombo: number[][];

    [key: string]: number[][];
}

export const MissionConfig: IMissionConfig = {
    collectStars: COLLECT_STARS,
    collectToys: COLLECT_TOYS,
    completeLevels: COMPLETE_LEVELS,
    matchTiles: MATCH_TILES,
    matchGold: MATCH_GOLD,
    use_hint: USE_HINT,
    use_firecracker: USE_FIRECRACKER,
    use_magnet: USE_MAGNET,
    reachCombo: REACH_COMBO,
};

export const MISSION_REFRESH_TIME = DateUtils.hoursToMilliseconds(8);

export const MISSION_MILESTONE_TOTAL = 10;

export function getMilestoneReward(milestone: number) {
    if (milestone < 3) {
        return { id: ItemIDs.COINS, val: 50 };
    } else {
        return getMilestonePresentReward();
    }
}

function getMilestonePresentReward() {
    const random = getRandom(1, 100);

    if (random < 25) {
        return { id: ItemIDs.FIRECRACKER, val: 1 };
    } else if (random < 50) {
        return { id: ItemIDs.MAGNET, val: 1 };
    } else if (random < 75) {
        return { id: ItemIDs.COINS, val: 100 };
    } else {
        return { id: ItemIDs.COINS, val: 150 };
    }
}
